import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProductContextProvider from "./context/ProductContextProvider";
import ProductsAll from "./context/ProductsAll";
import styles from "./ProductsList.module.css";
import { Helmet } from "react-helmet";
import Banner1 from "./images/Banners/ProductListBanner1.jpg";
import Banner2 from "./images/Banners/ProductListBanner2.jpg";
const ProductsList = () => {
  return (
    <>
      <Helmet>
        <title>
          خرید باتری یو پی اس صبا و واریان | قیمت روز باتری خودرو با گارانتی |
          باتری۱۰۰
        </title>
        <meta
          name="description"
          content="خرید و قیمت انواع باتری یو پی اس صبا، باتری خودرویی صبا، و باتری واریان با گارانتی معتبر و قیمت ارزان در فروشگاه باتری۱۰۰. مشاوره تخصصی و ارسال سریع به سراسر کشور."
        />
        <meta
          name="keywords"
          content="خرید و قیمت باتری یو پی اس صبا, باتری با گارانتی معتبر, باتری با قیمت ارزان, خرید و قیمت باتری واریان, باتری خودرویی صبا, باتری اتمی, باتری ماشین"
        />
        <meta
          property="og:title"
          content="فروشگاه تخصصی باتری خودرو و یو پی اس | باتری۱۰۰"
        />
        <meta
          property="og:description"
          content="خرید اینترنتی انواع باتری خودرو و یو پی اس با گارانتی معتبر و قیمت مناسب"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://battery100.ir/products" />
      </Helmet>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "فروشگاه باتری خودرو و یو پی اس",
          description:
            "فروشگاه تخصصی انواع باتری خودرو، یو پی اس و صنعتی با گارانتی معتبر",
          url: "https://battery100.ir/products",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://battery100.ir/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        })}
      </script>

      <Navbar />
      <main className={styles.maincontainer}>
        <h1 className={styles.mainTitle}>محصولات فروشگاه باتری۱۰۰</h1>
        <ProductContextProvider>
          <ProductsAll />
        </ProductContextProvider>

        <div className={styles.articleContainer}>
          <h2 className={styles.sectionTitle}>
            خرید و قیمت باتری یو پی اس صبا: انرژی پشتیبان برای دنیای دیجیتال
          </h2>
           {" "}
          <img
            src={Banner1}
            alt="خرید و قیمت باتری یو پی اس صبا"
            className={styles.articleImage}
          />
          <p>
            در دنیای پرشتاب امروز که لحظه‌ای قطع برق می‌تواند خسارات
            جبران‌ناپذیری به بار آورد، داشتن یک سیستم پشتیبان قوی از اهمیت
            بالایی برخوردار است. <strong>باتری یو پی اس صبا</strong>، پاسخی
            مطمئن به این نیاز حیاتی است. اگر به دنبال{" "}
            <strong>خرید و قیمت باتری یو پی اس صبا</strong> هستید، فروشگاه
            باتری۱۰۰ با ارائه محصولات باکیفیت و گارانتی معتبر، بهترین انتخاب را
            پیش روی شما قرار می‌دهد. ما با قیمت‌گذاری رقابتی، این امکان را فراهم
            کرده‌ایم تا به یک باتری با قیمت ارزان و در عین حال باکیفیت دسترسی
            داشته باشید.
          </p>
          <h3 className={styles.subSectionTitle}>
            باتری یو پی اس چیست و کاربرد آن در زندگی مدرن؟
          </h3>
          <p>
            یو پی اس (UPS) به معنای منبع تغذیه بدون وقفه است و وظیفه‌اش تامین
            برق در زمان‌های نوسان یا قطعی برق است.{" "}
            <strong>باتری یو پی اس</strong>، قلب تپنده این سیستم است که انرژی را
            برای محافظت از تجهیزات حیاتی ذخیره می‌کند. کاربردهای این باتری‌ها
            بسیار گسترده است، از تامین برق سرورها و مراکز داده برای جلوگیری از
            از دست رفتن اطلاعات، تا حفظ عملکرد دستگاه‌های حساس پزشکی و سیستم‌های
            امنیتی. کاربردهای باتری یو پی اس چیست؟ در واقع هر جایی که حفظ
            پایداری جریان برق ضروری باشد، این باتری‌ها حضور دارند.
          </p>
          <hr className={styles.divider} />
          <h2 className={styles.sectionTitle}>
            خرید و قیمت باتری خودرویی صبا: قدرت و اطمینان در جاده
          </h2>
          <img
            src={Banner2}
            alt="خرید و قیمت باتری خودرو صبا |واریان | آرمو"
            className={styles.articleImage}
          />
          <p>
            انتخاب باتری مناسب برای خودروی شما، تضمین‌کننده عملکرد روان و
            بی‌دردسر آن است. <strong>باتری خودرویی صبا</strong> با سال‌ها تجربه
            و کیفیت اثبات‌شده، یکی از محبوب‌ترین انتخاب‌ها در بازار است. در
            فروشگاه باتری۱۰۰، ما طیف کاملی از این باتری‌ها از جمله باتری واریان
            را با بهترین قیمت و گارانتی معتبر عرضه می‌کنیم. برای اطلاع از{" "}
            <strong>خرید و قیمت باتری واریان</strong> یا سایر مدل‌ها، کافیست
            مشخصات خودروی خود را وارد کرده تا باتری مناسب نمایش داده شود.
          </p>
          <h3 className={styles.subSectionTitle}>
            چطور بهترین باتری خودرو را انتخاب کنیم؟
          </h3>
          <p>
            انتخاب یک <strong>باتری خودرویی</strong> مناسب نیازمند توجه به چند
            نکته کلیدی است: آمپراژ (Ah) باتری باید با مشخصات خودروی شما همخوانی
            داشته باشد. ابعاد باتری نیز اهمیت زیادی دارد تا به درستی در جایگاه
            خود قرار گیرد. همچنین، نوع باتری (اتمی یا اسیدی) و تاریخ تولید آن از
            فاکتورهای مهمی هستند که بر طول عمر و عملکرد آن تأثیر می‌گذارند.
            باتری‌های اتمی صبا نیاز به نگهداری کمتری دارند و گزینه ایده‌آلی برای
            بسیاری از رانندگان هستند.
          </p>
          <hr className={styles.divider} />
          <h2 className={styles.sectionTitle}>
            گارانتی معتبر و قیمت ارزان: تعهد ما در باتری۱۰۰
          </h2>
          <p>
            ما در باتری۱۰۰ به اصالت و کیفیت محصولاتمان افتخار می‌کنیم. به همین
            دلیل، تمامی باتری‌های ما با گارانتی معتبر شرکتی ارائه می‌شوند. این
            گارانتی، خیال شما را از بابت هرگونه نقص احتمالی راحت می‌کند. همچنین،
            با عرضه مستقیم محصولات، موفق به حذف واسطه‌ها و ارائه باتری با قیمت
            ارزان و رقابتی شده‌ایم. هدف ما این است که تجربه‌ای بی‌نقص و مطمئن از
            خرید باتری را برای شما فراهم کنیم.
          </p>
          <p>
            با مراجعه به فروشگاه ما، چه به دنبال خرید و قیمت باتری یو پی اس صبا
            باشید و چه به دنبال باتری خودرویی صبا، می‌توانید با اطمینان کامل
            خرید خود را انجام دهید. کارشناسان ما آماده‌اند تا شما را در این
            انتخاب یاری کنند.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ProductsList;
